import { Pipe, PipeTransform } from '@angular/core';
import { PermissionsService } from '../../app/services/permission.service';

@Pipe({ name: 'hasPermission', pure: false }) // pure: false if data might change
export class HasPermissionPipe implements PipeTransform {
  constructor(private permissionService: PermissionsService) {}

  transform(url: string, action: string): boolean {
    return this.permissionService.hasPrivilege(url, action);
  }
}
